import {initAccordions} from 'flowbite/lib/esm/components/accordion/index';
import {initCollapses} from 'flowbite/lib/esm/components/collapse/index';
import Dropdown from 'flowbite/lib/esm/components/dropdown/index';
import {initModals} from 'flowbite/lib/esm/components/modal/index';
import {initDrawers} from 'flowbite/lib/esm/components/drawer/index';
import {initTabs} from 'flowbite/lib/esm/components/tabs/index';
import {initTooltips} from 'flowbite/lib/esm/components/tooltip/index';
import {initDismisses} from 'flowbite/lib/esm/components/dismiss/index';

// Same options initDropdowns() reads from the data attributes.
const _dropdownOptions = ($triggerElement) => {
    const options = {};

    const placement = $triggerElement.getAttribute('data-dropdown-placement');
    const triggerType = $triggerElement.getAttribute('data-dropdown-trigger');
    const offsetSkidding = $triggerElement.getAttribute('data-dropdown-offset-skidding');
    const offsetDistance = $triggerElement.getAttribute('data-dropdown-offset-distance');
    const delay = $triggerElement.getAttribute('data-dropdown-delay');
    const ignoreClickOutsideClass = $triggerElement.getAttribute('data-dropdown-ignore-click-outside-class');

    if (placement) options.placement = placement;
    if (triggerType) options.triggerType = triggerType;
    if (offsetSkidding) options.offsetSkidding = parseInt(offsetSkidding);
    if (offsetDistance) options.offsetDistance = parseInt(offsetDistance);
    if (delay) options.delay = parseInt(delay);
    if (ignoreClickOutsideClass) options.ignoreClickOutsideClass = ignoreClickOutsideClass;

    return options;
};

// A Dropdown creates its Popper instance as soon as it is built, which forces a layout: done for every
// header dropdown at boot, it sat in the page's longest task. Build each one on its first click instead.
// Hover-triggered dropdowns keep the eager path: their first interaction is not a click.
const _initDropdownsOnFirstClick = () => {
    document.querySelectorAll('[data-dropdown-toggle]').forEach(($triggerElement) => {
        const $dropdownElement = document.getElementById($triggerElement.getAttribute('data-dropdown-toggle'));
        if (!$dropdownElement) {
            return;
        }

        const options = _dropdownOptions($triggerElement);
        if (options.triggerType && options.triggerType !== 'click') {
            new Dropdown($dropdownElement, $triggerElement, options);
            return;
        }

        $triggerElement.addEventListener('click', () => {
            // Listeners the Dropdown adds to the trigger now do not run for this click: open it ourselves.
            new Dropdown($dropdownElement, $triggerElement, options).show();
        }, {once: true});
    });
};

export default function flowbiteInitializer() {
    initAccordions();
    initCollapses();
    _initDropdownsOnFirstClick();
    initModals();
    initDrawers();
    initTabs();
    initTooltips();
    initDismisses();
}
